// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brand-card-container[data-v-a393dbe8]{min-width:-webkit-fit-content;min-width:-moz-fit-content;min-width:fit-content}.brand-card-container .logo[data-v-a393dbe8]{height:60px;width:auto;display:block}@media (min-width:600px){.brand-card-container .logo[data-v-a393dbe8]{height:80px}}", ""]);
// Exports
module.exports = exports;
